import React from 'react';
import PropTypes from 'prop-types';

import pure from '../../lib/pure';

function LoadingIndicator({ isLoading }) {
  return (
    isLoading ? <i className="fa fa-circle-o-notch fa-spin" /> : <i className="icon-fixed-width" />
  );
}

LoadingIndicator.defaultProps = {
  isLoading: false,
};

LoadingIndicator.propTypes = {
  isLoading: PropTypes.bool,
};

export default pure(LoadingIndicator);
